import { Controller } from 'stimulus'

// A survey's Email tab: re-renders the branded email (survey_mailer/_email,
// through SurveyTemplatesController#email_preview) as the copy changes, and
// switches the preview between desktop and phone widths.
export default class extends Controller {
  static targets = ['form', 'subject', 'body'];

  connect() {
    this.narrow = false
    this.refresh(0)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  changed() {
    this.refresh(300)
  }

  width(event) {
    this.narrow = event.currentTarget.dataset.width === 'narrow'
    this.element.querySelectorAll('[data-width]').forEach(b => b.classList.toggle('is-on', b === event.currentTarget))
    this.bodyTarget.classList.toggle('is-narrow', this.narrow)
  }

  insertTag(event) {
    const button = event.currentTarget
    const box = document.getElementById(button.dataset.into)
    const start = box.selectionStart != null ? box.selectionStart : box.value.length
    const end = box.selectionEnd != null ? box.selectionEnd : start
    box.value = box.value.slice(0, start) + button.dataset.tag + box.value.slice(end)
    box.focus()
    box.selectionStart = start + button.dataset.tag.length
    box.selectionEnd = box.selectionStart
    this.changed()
  }

  // The form's own authenticity_token is a per-form token for saving it
  // (PATCH), which email_preview rejects; the page's token in the header is
  // what passes. A redirect (a rejected token, a signed-out session) comes
  // back as a whole page, which must never land inside the preview.
  refresh(delay) {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      const body = new FormData(this.formTarget)
      body.delete('_method')
      body.delete('authenticity_token')
      const meta = document.querySelector('meta[name="csrf-token"]')
      const request = (this.request || 0) + 1
      this.request = request
      fetch(this.data.get('url'), {
        method: 'POST', credentials: 'same-origin', headers: { 'X-CSRF-Token': meta ? meta.content : '' }, body
      })
        .then(response => (response.ok && !response.redirected ? response.text() : null))
        .then((html) => {
          if (html == null || request !== this.request) return
          const holder = document.createElement('div')
          holder.innerHTML = html
          const subject = holder.querySelector('[data-email-subject]')
          if (subject) {
            this.subjectTarget.textContent = subject.dataset.emailSubject
            subject.remove()
          }
          this.bodyTarget.innerHTML = holder.innerHTML
          this.bodyTarget.querySelectorAll('a').forEach((a) => {
            a.setAttribute('target', '_blank')
            a.setAttribute('rel', 'noopener')
          })
        })
        .catch(() => {})
    }, delay)
  }
}
